import styled from "styled-components";
import HomeButtonPrimaryMobile from "./HomeButtonPrimaryMobile";
import { useNavigate } from "react-router-dom";
import HomeButtonSecondaryMobile from "./HomeButtonSecondaryMobile";

const ButtonWrapperTop = styled.div`
  // padding-top: 8px;
  width: 100%;
  display: flex;
`;

const ButtonWrapper = styled.div`
  padding-top: 8px;
  width: 100%;
  display: flex;
`;

const ButtonPanelMobile = () => {
  const navigate = useNavigate();

  return (
    <>
      <ButtonWrapperTop>
        <HomeButtonPrimaryMobile
          text="SIGN IN"
          onClick={() => {
            navigate("/signin");
          }}
        />
      </ButtonWrapperTop>
      <ButtonWrapper>
        <HomeButtonSecondaryMobile
          text="Browse Petitions"
          onClick={() => {
            navigate("/petitions");
          }}
        />
      </ButtonWrapper>
      <ButtonWrapper>
        <HomeButtonSecondaryMobile
          text="About Verified Voice"
          onClick={() => {
            navigate("/about");
          }}
        />
      </ButtonWrapper>
    </>
  );
};

export default ButtonPanelMobile;
